// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2fYtf","sendOtp":"AuthorizeToLogin_sendOtp__ZOTCC"};